var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V13.8258L9.15081 12.2407C8.73148 11.8813 8.10018 11.9299 7.74076 12.3492C7.38134 12.7685 7.4299 13.3998 7.84923 13.7593L11.3492 16.7593C11.7237 17.0802 12.2763 17.0802 12.6508 16.7593L16.1508 13.7593C16.5701 13.3998 16.6187 12.7685 16.2593 12.3492C15.8999 11.9299 15.2686 11.8813 14.8492 12.2407L13 13.8258V3ZM4 16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V16C22 15.4477 21.5523 15 21 15C20.4477 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.becc5849fd4ca447a8f7b9c843ede6c4.svg";
export { ForwardRef as ReactComponent };